import withDraft from '@/utils/draftHelper';
import actions from '../data/constants';
import { closeDatasetState } from './state';

const closeDataManagementDataset = withDraft((draft, { code }) => {
  closeDatasetState(draft, { category: 'dataManagement', code });
});

export default {
  [actions.CLOSE_DATASET_DATA_MANAGEMENT]: closeDataManagementDataset,
};
